module.exports = __webpack_public_path__ + "static/img/bg-uy.aff2e3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/godfather/bg-uy.jpg
// module id = YP+P
// module chunks = 1